import {
    CASOSDETALLES_LIST,
    CASOSDETALLES_LISTA,
    CASOSDETALLES_FILTER,
    CASOSDETALLES_CREATE,
    CASOSDETALLES_UPDATE,
    CASOSDETALLES_UPDATE_SUCCESS,
    CASOSDETALLES_CREATE_SUCCESS,
    CASOSDETALLES_LIST_SUCCESS,
    CASOSDETALLES_REQUEST_FAILED,
    CASOSDETALLES_READ,
    CASOSDETALLES_READ_SUCCESS,

  } from "./actionTypes";
  
  export const casosDetallesList = () => {
    return {
      type: CASOSDETALLES_LIST,
      payload: {},
    };
  };
  export const casosDetallesLista = () => {
    return {
      type: CASOSDETALLES_LISTA,
      payload: {},
    };
  };
  
  export const casosDetallesCreate = (casosDetalles) => {
    return {
      type: CASOSDETALLES_CREATE,
      payload: casosDetalles,
    };
  };
  
  export const casosDetallesFilter = (changeUrl) => {
    return {
      type: CASOSDETALLES_FILTER,
      payload: { changeUrl },
    };
  };
  
  export const CasosRead = (id) => {
    return {
      type: CASOSDETALLES_READ,
      payload: {id},
    };
  };

  export const CasosDetallesReadSuccess = (data) => {
    return {
      type: CASOSDETALLES_READ_SUCCESS,
      payload: data,
    };
  };
  
  export const casosDetallesUpdate = (id, data) => {
    return {
      type: CASOSDETALLES_UPDATE,
      payload: { id, data },
    };
  };
  
  export const casosDetallesListSuccess = (casosDetalles) => {
    return {
      type: CASOSDETALLES_LIST_SUCCESS,
      payload: casosDetalles,
    };
  };
  
  export const casosDetallesCreateSuccess = (casosDetallesCreated) => {
    return {
      type: CASOSDETALLES_CREATE_SUCCESS,
      payload: casosDetallesCreated,
    };
  };
  
  export const casosDetallesUpdateSuccess = (casosDetalles) => {
    return {
      type: CASOSDETALLES_UPDATE_SUCCESS,
      payload: casosDetalles,
    };
  };
  
  export const casosDetallesRequestFailed = (error) => {
    return {
      type: CASOSDETALLES_REQUEST_FAILED,
      payload: error,
    };
  };
  